import { toast } from 'react-toastify';
import get from 'lodash/get';

export default (payload, options = {}) => {
  const { toast404 = true, toast401 = true } = options;
  const { status } = payload.response;

  switch (status) {
    case 401:
      if (toast401)
        toast.error(
          "You aren't authorized to perform this action. Are you logged in? Please try refreshing."
        );
      break;
    case 403:
      toast.error(
        "You aren't authorized to perform this action. Are you logged in? Please try refreshing."
      );
      break;
    case 404:
      if (toast404) toast.error("Whoops! This record wasn't found.");
      break;
    case 422:
      const errors = get(payload, ['response', 'data', 'errors']);
      if (errors) {
        errors.forEach(error => {
          const pointer = get(error, ['source', 'pointer']);
          if (pointer === '/data/attributes/base') toast.error(error.detail);
        });
      }
      break;
    case 500:
      toast.error(
        'Whoops! Something went wrong. Please let us know at help@jerseywatch.com'
      );
      break;
    default:
      toast.error(
        'Whoops! Something went wrong. Please refresh and try again.'
      );
  }
};
